let currentHandlers = {
    onCallConnect: null,
    onCDR: null,
    onRinging: null,
};

let _initialized = false;

export function initWebphone(data, phoneToCall) {
    const webphoneApi = window.webphone_api;

    if (!_initialized) {
        webphoneApi.setparameter('webrtcserveraddress', data.ip);
        webphoneApi.setparameter('username', data.login);
        webphoneApi.setparameter('password', data.password);

        webphoneApi.onAppStateChange((state) => {
            if (state === 'started' && !webphoneApi.isincall()) {
                webphoneApi.call(phoneToCall);
            }
        });

        webphoneApi.onEvents((event) => {
            const evtarray = event.split(',');

            if (evtarray[0] === 'STATUS' && evtarray[2] === 'Ringing') {
                currentHandlers.onRinging?.();
            } else if (evtarray[0] === 'STATUS' && evtarray[2] === 'CallConnect') {
                currentHandlers.onCallConnect?.(evtarray);
            } else if (evtarray[0] === 'CDR') {
                currentHandlers.onCDR?.(evtarray);
            }
        });

        webphoneApi.start();
        _initialized = true;
    }

    return webphoneApi;
}

export function resetWebphone(data) {
    const webphoneApi = window.webphone_api;
    webphoneApi.unregister();
    webphoneApi.delsettings?.(2);
    webphoneApi.stop();

    // Reinitialize SIP params
    webphoneApi.setparameter('webrtcserveraddress', data.ip);
    webphoneApi.setparameter('username', data.login);
    webphoneApi.setparameter('password', data.password);
    webphoneApi.start();
}

export function setWebphoneHandlers(handlers) {
    currentHandlers = handlers;
}
